// ** Routes Imports
import AppRoutes from './Apps'
import BrandsRoutes from './Brands'
import BrandsV2Routes from './Brands-v2'
import DashboardRoutes from './Dashboards'
import SupplierRoutes from './Suppliers'
import MiscRoutes from './Misc'

// ** Document title
const TemplateTitle = '%s - BeUni Dashboard'

// ** Default Route
const DefaultRoute = '/brands/experience'

// ** Merge Routes
const Routes = [
  ...AppRoutes,
  ...DashboardRoutes,
  ...BrandsRoutes,
  ...SupplierRoutes,
  ...MiscRoutes,
  ...BrandsV2Routes
]

export { DefaultRoute, TemplateTitle, Routes }
